;(function () {
  'use strict'
  angular
    .module('contrast.empty-row')
    .directive('csEmptyRow', function ($translate) {
      // Default message when no transclude value exists

      var translGlobal = {
        detail_noResultsFound: $translate.instant('detail_noResultsFound')
      }

      var _defaultMsg = translGlobal.detail_noResultsFound + '.'

      return {
        restrict: 'A',
        replace: true,
        transclude: true,
        templateUrl: 'views/cs-empty-row.html',
        scope: {},
        link: function (scope, elem, attrs, ctrl, transclude) {
          transclude(scope.$parent.$new(), function (clone) {
            if (clone.length) {
              scope.transcluded = true
            } else {
              angular.extend(scope, {
                defaultMsg: _defaultMsg,
                transcluded: false
              })
            }
            angular.extend(scope, {
              noPadding: attrs.hasOwnProperty('noPadding'),
              noFrills: attrs.hasOwnProperty('noFrills'),
              noBorder: attrs.hasOwnProperty('noBorder'),
              useDefaultMsg: attrs.hasOwnProperty('defaultMsg')
            })
          })
        }
      }
    })
})()
